import React, { useEffect, useState } from 'react';
import { tokenStorage } from '../utils/tokenStorage';
import toast from 'react-hot-toast';

const SessionMonitor: React.FC = () => {
  const [showWarning, setShowWarning] = useState(false);

  useEffect(() => {
    const updateTimer = () => {
      const timeLeft = tokenStorage.getTimeUntilSessionExpiry();

      // If session has completely expired, trigger logout
      if (timeLeft <= 0 && tokenStorage.hasTokens()) {
        console.log('Session expired, triggering logout...');
        window.dispatchEvent(new CustomEvent('auth:logout'));
        return;
      }

      // Show warning if less than 15 minutes remaining
      if (timeLeft > 0 && timeLeft < 15 * 60 * 1000 && !showWarning) {
        setShowWarning(true);
        toast((t) => (
          <div className="flex flex-col">
            <span className="font-medium">Session Expiring Soon</span>
            <span className="text-sm text-gray-600">
              Your session will expire in {Math.ceil(timeLeft / 60000)} minutes.
              Please save your work and stay active to keep your session.
            </span>
            <button
              className="mt-2 px-3 py-1 text-sm bg-blue-600 text-white rounded hover:bg-blue-700"
              onClick={() => {
                toast.dismiss(t.id);
                setShowWarning(false);
                // User activity will refresh the session
                tokenStorage.updateLastActivity();
                // Also make a lightweight API call to extend session
                fetch('/api/auth/ping', { 
                  method: 'GET',
                  credentials: 'include'
                }).catch(err => console.log('Ping failed:', err));
              }}
            >
              Keep me logged in
            </button>
          </div>
        ), {
          duration: 0, // Don't auto-dismiss
          icon: '⏰',
        });
      }

      // Reset warning when session is refreshed
      if (timeLeft > 15 * 60 * 1000 && showWarning) {
        setShowWarning(false);
      }
    };

    // Update every 30 seconds
    const interval = setInterval(updateTimer, 30000);
    updateTimer(); // Initial update

    return () => clearInterval(interval);
  }, [showWarning]);

  // Track user activity
  useEffect(() => {
    const trackActivity = () => {
      tokenStorage.updateLastActivity();
    };

    // Track various user activities
    const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart', 'click'];
    
    events.forEach(event => {
      document.addEventListener(event, trackActivity, true);
    });

    return () => {
      events.forEach(event => {
        document.removeEventListener(event, trackActivity, true);
      });
    };
  }, []);

  // Don't render anything visible - this is just a monitoring component
  return null;
};

export default SessionMonitor;